export default __webpack_public_path__ + "static/media/Forgot_password.2d57ccef.svg";